import { ObservationService } from '../../../shared/observation/observation.service';
import { Component, OnChanges, QueryList, ViewChildren, Input, OnInit } from '@angular/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../../shared/widgets/value-accessors/object-value-accessor';
import { ProfileAddress } from '../../shared/profileAddress.model';
import { ProfileService } from '../../shared/profile.service';
import { ProfileEditAddressComponent } from './profile-edit-address.component';
@Component({
  selector: 'wl-profile-edit-address-list',
  templateUrl: 'profile-edit-address-list.component.html',
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditAddressListComponent),
    CreateObjectValueValidationProvider(ProfileEditAddressListComponent),
  ],
    standalone: false
})
export class ProfileEditAddressListComponent extends ObjectValueAccessor<Array<ProfileAddress>> implements OnInit, OnChanges {
  @Input() profileId: number;
  @ViewChildren(ProfileEditAddressComponent) _addressComponents: QueryList<ProfileEditAddressComponent>;

  private _deletedAddresses = new Array<ProfileAddress>();

  public constructor(private _profileService: ProfileService, private _observationService: ObservationService) {
    super([], false);
    this.value = new Array<ProfileAddress>();
  }

  ngOnInit() {
    this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });
  }

  ngOnChanges() {
    if (this.profileId) {
      this.loadData();
    }
  }

  addAddress() {
    this.value.push({} as ProfileAddress);
  }

  deleteAddress(index: number) {
    let deleted = this.value.splice(index, 1);
    if (deleted.length > 0) {
      this._deletedAddresses.push(deleted[0]);
    }
  }

  save() {
    const promises: Array<Promise<void>> = [];
    this._addressComponents.forEach((component) => {
      promises.push(component.save(this.profileId));
    });
    this._deletedAddresses.forEach((deleted) => {
      promises.push(this._profileService.deleteProfileAddress(deleted.ID));
    });
    return promises;
  }

  private loadData() {
    this._profileService.getAllProfileAddressed(this.profileId).then((data) => {
      this.value = data;
    });
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadData();
    }
  }
}
